// Роль, от которой зависят адреса запросов (seller / distributor).
// Хранится отдельно от auth.machine, чтобы не создавать циклический импорт.
export const apiRole = { isDedicatedDistributor: false };
